import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { credentialsInterceptor } from './core/api/credentials.interceptor';
import { messageToastInterceptor } from './core/api/message-toast.interceptor';
import { unauthorizedInterceptor } from './core/api/unauthorized.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(
      withInterceptors([
        credentialsInterceptor,
        unauthorizedInterceptor,
        messageToastInterceptor,
      ]),
    ),
    provideRouter(routes),
  ],
};
